// src/App.js

import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import './GPTW.css';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Login from './pages/Login';
import Home from './pages/Home';
import ActionBoard from './pages/ActionBoard';
import Settings from './pages/Settings';
import MainDashboard from './pages/Dashboard';
import UserManagement from './pages/UserManagement';
import Checkpoints from './pages/Checkpoints';
import PrivateRoutes from './PrivateRoutes';
import PublicRoutes from './PublicRoutes';
import ResetPassword from './pages/ResetPassword';
import Datenschutz from './pages/Datenschutz';
import "flag-icons/css/flag-icons.min.css";
import { selectIsAuthenticated } from './features/authSlice';

function App() {
    const isAuthenticated = useSelector(selectIsAuthenticated);

    return (
        <Router>
            <div className="App">
                <Routes>
                    {/* Public Routes */}
                    <Route element={<PublicRoutes />}>
                        <Route path="/login" element={<Login />} />
                        <Route path="/reset-password/:uid/:token" element={<ResetPassword />} />
                        <Route path="/reset-password" element={<ResetPassword />} />
                    </Route>

                    {/* Standalone Public Routes (accessible regardless of auth state) */}
                    <Route path="/datenschutz" element={<Datenschutz />} />

                    {/* Root Route */}
                    <Route
                        path="/"
                        element={
                            isAuthenticated ? <Navigate to="/home" replace /> : <Navigate to="/login" replace />
                        }
                    />

                    {/* Protected Routes */}
                    <Route element={<PrivateRoutes />}>
                        <Route path="/actionboard" element={<ActionBoard />} />
                        <Route path="/actionboard/:actionarea_slug" element={<ActionBoard />} />
                        <Route path="/settings" element={<Settings />} />
                        <Route path="/dashboard" element={<MainDashboard />} />
                        <Route path="/user_management" element={<UserManagement />} />
                        <Route path="/checkpoints" element={<Checkpoints />} />
                        <Route path="/home" element={<Home />} />
                    </Route>

                    {/* Catch-all Route for Undefined Paths */}
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </div>
        </Router>
    );
}

export default App;
